import { render, staticRenderFns } from "./pwa_general_tab.vue?vue&type=template&id=553a0aca&scoped=true&"
import script from "./pwa_general_tab.vue?vue&type=script&lang=js&"
export * from "./pwa_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a0aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553a0aca')) {
      api.createRecord('553a0aca', component.options)
    } else {
      api.reload('553a0aca', component.options)
    }
    module.hot.accept("./pwa_general_tab.vue?vue&type=template&id=553a0aca&scoped=true&", function () {
      api.rerender('553a0aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/location/tabs/pwa_general_tab.vue"
export default component.exports